import React from 'react';
import I18n from 'i18n-js';
import { number, string } from 'prop-types';
import { Typography } from 'antd';
import { ArrowDownOutlined, ArrowUpOutlined, CheckOutlined } from '@ant-design/icons';
import { gold, green, purple } from '@ant-design/colors';

import { formatQuantity } from 'helpers/quantity';

// Fixed palette, not theme tokens: the CWO theme overrides colorWarning to a
// brown (#9A6412), but the badge semantics need a yellow shortfall indicator.
const STATE_CONFIG = {
  shortfall: { Icon: ArrowDownOutlined, color: gold[6] },
  within: { Icon: CheckOutlined, color: green[6] },
  overshoot: { Icon: ArrowUpOutlined, color: purple[6] },
};

const DeliveryDiffBadge = ({ state, amount = 0 }) => {
  const config = STATE_CONFIG[state];

  if (!config) return null;

  const { Icon, color } = config;
  const text = I18n.t(`wh_documents.delivery_difference.${state}`, {
    amount: formatQuantity(amount),
  });

  return (
    <Typography.Text style={{ color }}>
      <Icon />
      {' '}
      {text}
    </Typography.Text>
  );
};

DeliveryDiffBadge.propTypes = {
  state: string.isRequired,
  amount: number,
};

export default DeliveryDiffBadge;
